module.exports = __webpack_public_path__ + "assets/1bc533a703937d232c8448bfab5e6dd4.jpg";